import axios from "axios";
const { REACT_APP_CHATBOT_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

const apiService = axios.create({
  baseURL: REACT_APP_CHATBOT_URL,
  headers: {
    emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
  },
});

// GET 요청을 처리하는 서비스 함수
const requestTicket = (chatBotType, phoneNumber) => {
  return apiService.get(`/ticket/make_url/${chatBotType}/${phoneNumber}`);
};
export default requestTicket;
